import './lib/leaving-site.js'
import {getCookie} from "./lib/util.js";

function initialiseCookiesBar() {
    const COOKIE_SELECTION_LEVEL_NAME = "servicefirst.cookielevelselection";
    const COOKIE_CONSENT_LEVEL_NAME = "servicefirst.cookieconsentlevel";
    const cookieBar = document.querySelector("[xp-cookie-banner]");
    
    const cookieValue = getCookie(COOKIE_SELECTION_LEVEL_NAME);
    const cookieLevelValue = getCookie(COOKIE_CONSENT_LEVEL_NAME);

    if (!cookieBar || cookieValue === "true" || cookieLevelValue === "4") {
        return;
    }

    const cookieBarCtas = document.querySelectorAll("[cookie-cta]");

    cookieBarCtas.forEach(function (elem) {
        elem.addEventListener("click", () => {
            cookieBar.classList.remove("is-active");
        });
    });
}

function initialiseCookiePreferences() {
    const options = document.querySelectorAll(".cookie-preferences__option");
    const rangeInput = document.querySelector("#CookieLevelSelected");

    // Setup options
    for (let i = 0; i < options.length; i++) {
        const option = options[i];
        option.addEventListener(
            "click",
            function () {
                selectOption(option);
            },
            false,
        );
        option.style.top =
            (300 / (options.length - 1)) * i - options.length * (i * 2) + "px";
    }

    if (rangeInput) {
        // Setup range input
        rangeInput.addEventListener("input", changeRange, false);

        // Init range fill
        changeRange();
    }
}

function changeRange() {
    const rangeInput = document.querySelector("#CookieLevelSelected");
    const rangeFill = document.querySelector("#range-fill");
    let percent = (parseInt(rangeInput.value) - 1) * 33;
    if (percent < 5) percent += 5;

    rangeFill.style.width = percent + "%";
}

function selectOption(option) {
    const rangeInput = document.querySelector("#CookieLevelSelected");
    const optionValue = option.getAttribute("data-value");
    rangeInput.value = optionValue;
    changeRange();
}
function initialiseDealerSearch(){
    const form = document.querySelector(".dealer-form");
    if(form){
        const page = form;
        
        form.querySelector(`input[type='search']`)
            .addEventListener("keypress", function(e){
                if(e.key === "Enter"){
                    e.preventDefault();
                    e.stopPropagation();
                    console.log(e.key)
                }
        })
    }
}

document.addEventListener("DOMContentLoaded", () => {
    initialiseCookiesBar();
    initialiseCookiePreferences();
    initialiseDealerSearch();
});